import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, FlaskConical } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileRDItemDetailPage() {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/rd/items/${itemId}`).catch(() => {
      // Try pending items
      return axios.get(`${API}/rd/pending-items/${itemId}`);
    }).then(r => setItem(r?.data || null)).catch(() => {}).finally(() => setLoading(false));
  }, [itemId]);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;
  if (!item) return <div className="mobile-page"><button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button><div className="mobile-empty-state"><p>Item not found</p></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button>
      <div className="mobile-detail-section" style={{ textAlign: 'center', paddingTop: 20, paddingBottom: 20 }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: '#5856d6', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px', color: 'white' }}><FlaskConical size={24} /></div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#1c1c1e' }}>{item.name || item.item_name}</div>
        <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginTop: 8 }}>
          <span className={`mobile-status-badge ${item.status === 'active' ? 'in_production' : 'scheduled'}`}>{item.status || 'draft'}</span>
          {item.review_status && <span className="mobile-status-badge staged">{item.review_status}</span>}
        </div>
      </div>
      <div className="mobile-kpi-row">
        {item.selling_price != null && <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Selling Price</div><div className="mobile-kpi-value" style={{ fontSize: 20 }}>${item.selling_price?.toFixed(2) || '—'}</div></div>}
        {item.total_cost != null && <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Total Cost</div><div className="mobile-kpi-value" style={{ fontSize: 20 }}>${item.total_cost?.toFixed(2) || '—'}</div></div>}
        {item.margin_percent != null && <div className="mobile-kpi-card" style={{ borderLeftColor: item.margin_percent >= 25 ? '#34c759' : item.margin_percent >= 20 ? '#ff9500' : '#ff3b30' }}><div className="mobile-kpi-label">Margin</div><div className="mobile-kpi-value" style={{ fontSize: 20 }}>{item.margin_percent?.toFixed(1) || '—'}%</div></div>}
      </div>
      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">Details</div>
        {item.description && <div className="mobile-detail-row"><span className="mobile-detail-label">Description</span><span className="mobile-detail-value" style={{ maxWidth: '60%', textAlign: 'right' }}>{item.description}</span></div>}
        {item.customer_name && <div className="mobile-detail-row"><span className="mobile-detail-label">Customer</span><span className="mobile-detail-value">{item.customer_name}</span></div>}
        {item.broker_name && <div className="mobile-detail-row"><span className="mobile-detail-label">Broker</span><span className="mobile-detail-value">{item.broker_name}</span></div>}
        {item.summary && <div style={{ marginTop: 8, fontSize: 13, color: '#636366', lineHeight: 1.5 }}>{item.summary}</div>}
      </div>
    </div>
  );
}
